import script from "./Branch.vue?vue&type=script&setup=true&lang=js"
export * from "./Branch.vue?vue&type=script&setup=true&lang=js"

import "./Branch.vue?vue&type=style&index=0&id=598cce78&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598cce78"]])

export default __exports__